import { PayPalButtons } from '@paypal/react-paypal-js';
import { API_URL, URLS } from '../../_config';
import { useToken } from '../../_common/hooks/authHook';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const PayPalButton = ({ amount, proposalId, _currency, discountAmount }: any) => {
    const tokenData: any = useToken();
    const navigate: any = useNavigate();

    console.log('proposalId', amount, proposalId, _currency);

    return (
        <div>
            {
                amount > 0 && <>
                    <h2>Pay with PayPal</h2>
                    <PayPalButtons
                        style={{ layout: 'vertical' }}
                        createOrder={(data: any, actions: any) => {
                            return actions.order.create({
                                purchase_units: [{
                                    amount: {
                                        currency_code: _currency,
                                        value: amount, // Replace with dynamic amount
                                    },
                                }],
                            });
                        }}
                        onApprove={(data: any, actions: any) => {
                            return actions.order.capture().then((result: any) => {
                                console.log('Transaction completed by', result);
                                let params = {
                                    status: result.status,
                                    proposal_id: proposalId,
                                    amount: result.purchase_units[0].amount?.value,
                                    currency: result.purchase_units[0].amount?.currency_code,
                                    transaction_id: result.id,
                                    payment_method: result?.intent,
                                    // payment_method_types: result.intent,
                                    return_data: JSON.stringify(result),
                                    payment_type: 'Paypal',
                                    transaction_date: new Date().toISOString(),
                                    discount_amount: discountAmount ?? 0,
                                }
                                fetch(API_URL.PAYMENTS.PAYPAL_PAYMENT_STORE, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenData}` },
                                    body: JSON.stringify(params),
                                })
                                    .then(response => response.json())
                                    .then(resp => {
                                        if (resp?.status == 200) { // Success  
                                            toast.success(resp?.message);
                                            navigate(URLS.ACCOUNT.PAYMENT.THANK_YOU)
                                        } else { // Error
                                            toast.error(resp?.message);
                                        }
                                    })
                                    .catch(error => { // Error
                                        toast.error(error);
                                    });
                            });
                        }}
                        onError={(err) => {
                            console.error('PayPal Checkout Error:', err);
                        }}
                    />
                </>
            }

        </div>
    );
};

export default PayPalButton;
